<script>
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import {
		loading,
		CPOEditData,
		errorMessage,
	} from "../../../../store/store";
	import { updateCpoProvider } from "../../../../services/evCharging";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import { onDestroy } from "svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { extractErrorMessage } from "../../../../utils/misc";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idMake = window.location.pathname.split(
		"master-data/vehicle-data/cpo-provider/edit/"
	)[1];
	const cpoProvider = field("cpoProvider", $CPOEditData.name, [required()]);
	const myForm = form(cpoProvider);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await updateCpoProvider(idMake, $cpoProvider.value);

			if (res.status === 200 && res.data.data.code === 0) {
				navigate("/master-data/vehicle-data/cpo-provider");
			} else {
				loading.set(false);
				extractErrorMessage(
					`${res.data.data.code} : ${res.data.data.message}`
				);
			}

			load = false;
			loading.set(false);
		} catch (error) {
			extractErrorMessage(error);
			load = false;
			loading.set(false);
		}
	};

	onDestroy(() => {
		CPOEditData.set("");
		errorMessage.set("");
	});
</script>

<Row>
	<ErrorMessageHandler message={$errorMessage} />
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="EV CPO Provider Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit EV CPO Provider</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> EV CPO Provider Name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$cpoProvider.value}
						error={$myForm.hasError("cpoProvider.required")}
						errorText={$myForm.hasError("cpoProvider.required")
							? "CPO Provider is required"
							: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$cpoProvider.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								UPDATE
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
